import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Col, Row, Tag, UploadFile } from "antd";
import clsx from "clsx";
import { IMediaOutputModel } from "interfaces/media";
import { CSSProperties, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import "../../../../components/FileUploads/FileUploads.style.scss";
import MediaUploadModal from "../../Media/MediaList/MediaUploadModal/MediaUploadModal.presenter";
import { GridContextProvider, GridDropZone, GridItem, swap } from "react-grid-dnd";
import { ListManager } from "react-beautiful-dnd-grid";

export interface IInventoryImageFormProps {
  value?: UploadFile[];
  onChange?: (value: UploadFile<any> | UploadFile<any>[]) => void;
  isThumbnail?: boolean;
  // onChangeThumbnail?: (value: any) => void;
  // thumbnail?: any;
  style?: CSSProperties;
  limit?: number;
  isMultipleSelect?: boolean;
}

export default function InventoryImageForm(props: IInventoryImageFormProps) {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [visibleMedia, setVisibleMedia] = useState(false);
  const [activeKey, setActiveKey] = useState<string>("2");

  // const [selectedImage, setSelectedImage] = useState<string | null>(null);
  // const [previewFile, setPreviewFile] = useState<string | null>(null);
  // const [selectedThumbnail, setSelectedThumbnail] = useState<any>(null);

  // useEffect(() => {
  //   if (!props.thumbnail) return;
  //   // console.log(24, props.value);
  //   // console.log(25, props.thumbnail);

  //   const dataThumbnails = fileList.filter((f) => ({
  //     ...f,
  //     isThumbnail: f.uid === props.thumbnail.uid,
  //   }));
  //   setFileList(dataThumbnails);
  //   // setSelectedImage(props.thumbnail.uid);
  // }, [props.thumbnail]);

  useEffect(() => {
    if (!props.value || !props.value.length) return;
    setFileList(props.value);
  }, [props.value]);

  const reorder = (list: any, startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const move = (source: any, destination: any, droppableSource: any, droppableDestination: any) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result: any = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
  };

  function onDragEnd(result: any) {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    const sInd = source.droppableId;
    const dInd = destination.droppableId;

    if (sInd === dInd) {
      const items: any[] = reorder(fileList, source.index, destination.index);
      // const newState: any = [...fileList];
      // newState[sInd] = items;
      setFileList(items);
      send(items);
    } else {
      const result = move(fileList[sInd], fileList[dInd], source, destination);
      const newState = [...fileList];
      newState[sInd] = result[sInd];
      newState[dInd] = result[dInd];

      setFileList(newState.filter((group: any) => group.length));
    }
  }

  const send = (value: UploadFile<any> | UploadFile<any>[]) => {
    props.onChange && props.onChange(value);
  };

  const onChangeThumbnail = (item: UploadFile) => {
    if (!props.isThumbnail) return;

    const dataThumbnails = fileList.map((f) => ({
      ...f,
      isThumbnail: f.uid === item.uid,
    }));
    send(dataThumbnails);
  };

  const handleAddMedia = (item: IMediaOutputModel[]) => {
    const cFileList: any[] = [
      ...fileList,
      ...item.map((i) => ({
        uid: uuidv4(),
        name: i.title,
        url: i.path,
        status: "done",
        isThumbnail: false,
        originId: i.id,
      })),
    ];
    send(cFileList);
    setVisibleMedia(false);
  };

  // target id will only be set if dragging from one dropzone to another.
  function onChangeGridView(sourceId: string, sourceIndex: number, targetIndex: number, targetId?: string) {
    const nextState = swap(fileList, sourceIndex, targetIndex);
    setFileList(nextState);
  }

  const ListElement = (props: any) => (
    <div className="list-images">
      <div className="list-images__item">
        <Row
          gutter={[12, 12]}
          className={clsx([
            { "list-images__item-wrapper": true },
            { "list-images__item-wrapper-active": props.item?.isThumbnail },
            // { "list-images__item-wrapper-active": selectedImage === data.uid },
          ])}
          onClick={() => {
            // props.onChangeThumbnail && props.onChangeThumbnail(data);
            onChangeThumbnail(props.item);
          }}
        >
          <Col span={10} style={{ height: "100%" }}>
            <img
              src={props.item?.url}
              alt={props.item?.name}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              loading="lazy"
              onClick={() => {
                // props.item?.url && setPreviewFile(props.item?.url);
              }}
            />
          </Col>
          <Col span={12} className="d-flex items-center">
            <p className="text-overflow-2-lines">
              <span>{props.item?.isThumbnail && <Tag color="#108ee9">Thumbnail</Tag>}</span>
              {props.item?.name}
            </p>
          </Col>
          <Col span={2} className="d-flex items-flex-start">
            <CloseCircleOutlined
              style={{ fontSize: 18 }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                // if (props.item?.isThumbnail) {
                //   // setSelectedThumbnail(null);
                //   // props.onChangeThumbnail && props.onChangeThumbnail(null);
                // }
                const filterFileList = fileList.filter((file) => file.uid !== props.item?.uid);
                setFileList(filterFileList);
                send(filterFileList);
              }}
            />
          </Col>
        </Row>
      </div>
    </div>
  );

  const noop = function (sourceIndex: number, destinationIndex: number) {
    const cFileList = [...fileList];
    cFileList[sourceIndex] = fileList[destinationIndex];
    cFileList[destinationIndex] = fileList[sourceIndex];
    setFileList(cFileList);
    send(fileList);
  };

  return (
    <div className="file-uploads" style={{ ...(props.style || {}) }}>
      {visibleMedia && (
        <MediaUploadModal
          visible={visibleMedia}
          isMultipleSelect={props?.isMultipleSelect}
          activeKey={activeKey as any}
          onClose={() => setVisibleMedia(false)}
          onUploadCompleted={() => {
            setActiveKey("2");
          }}
          onChooseCompleted={handleAddMedia}
          onChangeActiveKey={setActiveKey}
        />
      )}

      <div className="w_100">
        <Button
          size="large"
          color="primary"
          variant="dashed"
          className="mb_1 mt_1 w_100"
          onClick={() => setVisibleMedia(true)}
          disabled={props.limit ? fileList?.length >= props.limit : false}
        >
          Thêm ảnh vào thư viện sản phẩm
        </Button>
      </div>

      <ListManager
        items={fileList}
        direction="horizontal"
        maxItems={2}
        render={(item) => <ListElement item={item} />}
        onDragEnd={noop}
      />

      {false && (
        <div className="list-images">
          <GridContextProvider onChange={onChangeGridView}>
            <GridDropZone id="items" boxesPerRow={2} rowHeight={110}>
              {(fileList || []).map((data: any, idx) => (
                <GridItem className="list-images__item">
                  <Row
                    gutter={[12, 12]}
                    className={clsx([
                      { "list-images__item-wrapper": true },
                      { "list-images__item-wrapper-active": data.isThumbnail },
                      // { "list-images__item-wrapper-active": selectedImage === data.uid },
                    ])}
                    onClick={() => {
                      // props.onChangeThumbnail && props.onChangeThumbnail(data);
                      onChangeThumbnail(data);
                    }}
                  >
                    <Col span={10} style={{ height: "100%" }}>
                      <img
                        src={data.url}
                        alt={data.name}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        onClick={() => {
                          // data.url && setPreviewFile(data.url);
                        }}
                      />
                    </Col>
                    <Col span={12} className="d-flex items-center">
                      <p className="text-overflow-2-lines">
                        <span>{data.isThumbnail && <Tag color="#108ee9">Thumbnail</Tag>}</span>
                        {data.name}
                      </p>
                    </Col>
                    <Col span={2} className="d-flex items-flex-start">
                      <CloseCircleOutlined
                        style={{ fontSize: 18 }}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          // if (data.isThumbnail) {
                          //   // setSelectedThumbnail(null);
                          //   // props.onChangeThumbnail && props.onChangeThumbnail(null);
                          // }
                          const filterFileList = fileList.filter((file) => file.uid !== data.uid);
                          setFileList(filterFileList);
                          send(filterFileList);
                        }}
                      />
                    </Col>
                  </Row>
                </GridItem>
              ))}
            </GridDropZone>
          </GridContextProvider>
        </div>
      )}

      {false && (
        <DragDropContext onBeforeCapture={(e) => console.log(e)} onDragEnd={onDragEnd}>
          <Droppable droppableId="list-images">
            {(provided, snapshot) => {
              return (
                <div className="list-images" ref={provided.innerRef} {...provided.droppableProps}>
                  {(fileList || []).map((data: any, idx: number) => {
                    return (
                      <Draggable key={idx} draggableId={String(idx)} index={idx}>
                        {(provided, snapshot) => {
                          return (
                            <div className="list-images__item">
                              <Row
                                gutter={[12, 12]}
                                className={clsx([
                                  { "list-images__item-wrapper": true },
                                  { "list-images__item-wrapper-active": data.isThumbnail },
                                  // { "list-images__item-wrapper-active": selectedImage === data.uid },
                                ])}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                onClick={() => {
                                  // props.onChangeThumbnail && props.onChangeThumbnail(data);
                                  onChangeThumbnail(data);
                                }}
                              >
                                <Col span={10} style={{ height: "100%" }}>
                                  <img
                                    src={data.url}
                                    alt={data.name}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    loading="lazy"
                                    onClick={() => {
                                      // data.url && setPreviewFile(data.url);
                                    }}
                                  />
                                </Col>
                                <Col span={12} className="d-flex items-center">
                                  <p className="text-overflow-2-lines">
                                    <span>{data.isThumbnail && <Tag color="#108ee9">Thumbnail</Tag>}</span>
                                    {data.name}
                                  </p>
                                </Col>
                                <Col span={2} className="d-flex items-flex-start">
                                  <CloseCircleOutlined
                                    style={{ fontSize: 18 }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      // if (data.isThumbnail) {
                                      //   // setSelectedThumbnail(null);
                                      //   // props.onChangeThumbnail && props.onChangeThumbnail(null);
                                      // }
                                      const filterFileList = fileList.filter((file) => file.uid !== data.uid);
                                      setFileList(filterFileList);
                                      send(filterFileList);
                                    }}
                                  />
                                </Col>
                              </Row>
                            </div>
                          );
                        }}
                      </Draggable>
                    );
                  })}
                </div>
              );
            }}
          </Droppable>
        </DragDropContext>
      )}
    </div>
  );
}
